import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "oral"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = {
  class: "question"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["onClick"];
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = ["src"];
const _hoisted_9 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_withDirectives(_createElementVNode("div", {
    class: "icon play-icon loading-ani",
    onClick: _cache[0] || (_cache[0] = () => {
      $setup.pause('audio_oral');
      $setup.audioStatus = 0;
    })
  }, null, 512), [[_vShow, $setup.audioStatus == 1]]), _withDirectives(_createElementVNode("div", {
    class: "icon pause-icon-text",
    onClick: _cache[1] || (_cache[1] = () => {
      $setup.play('audio_oral');
      $setup.audioStatus = 1;
    })
  }, null, 512), [[_vShow, $setup.audioStatus == 0]]), _createElementVNode("p", {
    innerHTML: $props.questionInfo.itemInstruction
  }, null, 8, _hoisted_3)]), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.questionInfo.questionGroupList, (questionItem, questionIndex) => {
    return _openBlock(), _createElementBlock("div", {
      key: 'questionIndex' + questionIndex
    }, [_withDirectives(_createElementVNode("div", {
      class: "icon play-icon loading-ani",
      onClick: () => {
        $setup.pause('question_audio_oral');
        $setup.questionAudioStatus[questionIndex] = 0;
      }
    }, null, 8, _hoisted_5), [[_vShow, $setup.questionAudioStatus[questionIndex] == 1 && questionItem.audioList[0]]]), _withDirectives(_createElementVNode("div", {
      class: "icon pause-icon-text",
      onClick: () => {
        $setup.play('question_audio_oral', questionIndex);
        $setup.questionAudioStatus[questionIndex] = 1;
      }
    }, null, 8, _hoisted_6), [[_vShow, $setup.questionAudioStatus[questionIndex] == 0 && questionItem.audioList[0]]]), _createElementVNode("div", {
      class: "question-text",
      innerHTML: $setup.clearText(questionItem.questionList[0].questionStem)
    }, null, 8, _hoisted_7)]);
  }), 128))]), _createElementVNode("audio", {
    id: "audio_oral",
    onEnded: _cache[2] || (_cache[2] = $event => $setup.audioStatus = 0),
    controls: "",
    style: {
      "display": "none"
    },
    preload: "none"
  }, [_createElementVNode("source", {
    src: $props.questionInfo.itemInstructionAudio,
    type: "audio/mpeg"
  }, null, 8, _hoisted_8)], 32), _createElementVNode("audio", {
    id: "question_audio_oral",
    onEnded: _cache[3] || (_cache[3] = $event => $setup.questionAudioStatus[$setup.taskNo] = 0),
    controls: "",
    style: {
      "display": "none"
    },
    preload: "none"
  }, [_createElementVNode("source", {
    src: $props.questionInfo.questionGroupList[$setup.taskNo].audioList[0] ? $props.questionInfo.questionGroupList[$setup.taskNo].audioList[0].mediaName : '',
    type: "audio/mpeg"
  }, null, 8, _hoisted_9)], 32)]);
}